import React, { FC, useMemo } from 'react';
import { Trigger } from 'components/molecules/squad-picker/trigger';
import {
  AssigneeValue,
  TeamId,
  UserId,
} from 'components/organisms/tasks/fields';
import { CellRendererParams } from 'components/organisms/timesheets/drawers/calendar-integration/add-activity-page/activity-table';
import { fullName } from 'utils/full-name';
import { getRandomColor } from 'utils/get-random-color';

export const AssigneeRenderer: FC<CellRendererParams> = ({ value }) => {
  const assignee = useMemo(
    () =>
      value.users
        .map((u) => ({
          value: AssigneeValue.toString(UserId(u.userId)),
          label: fullName(u),
          imageUrl: u.photoUrl,
          color: getRandomColor(u.userId),
          roleId: u.role?.roleId,
          extra: {
            id: u.userId,
            type: 'user',
          },
        }))
        .concat(
          value.teams.map((t) => ({
            value: AssigneeValue.toString(TeamId(t.teamId)),
            label: t.teamName,

            color: getRandomColor(t.teamId),
            roleId: t.roleId,
            extra: {
              id: t.teamId,
              type: 'team',
              teamType: t.teamType,
            },
          })),
        ),
    [value.teams, value.users],
  );

  return <Trigger value={assignee} isMini />;
};
